import React, {Component} from 'react';
import {connect} from 'react-redux';
import { Link } from 'react-router-dom';
import stringToColor from '../../utils/stringToColor';
import UserBox from '../Helpers/User/UserBox';
import { inject, observer } from 'mobx-react'
import { toJS, makeObservable, observable } from 'mobx'


//actions
import setChatState from '../../actions/chat/setChatState';
import appendChatOpenedWindows from '../../actions/chat/appendChatOpenedWindows';


class ChatListItem extends Component {
  renderAvatar() {
    if (this.props.users) {
      if(this.props.users.length == 1) {
        return (
          <div>
            <UserBox
              avatar={this.props.users[0].user_table_avatar}
              nick={this.props.users[0].user_table_nick}
              size={50}
            />
          </div>
        );
      }
    } else {
      //Если в групповом чате только ты сам, массив users не возвращается
      return (
        <div>
          <UserBox
            avatar={null}
            nick={this.props.name}
            size={50}
          />
        </div>
      );
    }

    return (
      <div style={{width:54, height: 53, marginLeft:-1, marginTop:-1}} className="ofh">
        {this.props.users.map((item,index)=>{
          return (
            <UserBox
              key={index}
              avatar={item.user_table_avatar}
              nick={item.user_table_nick}
              className="fl"
              style={{margin:1}}
              size={24}
            />
          );
        })}
      </div>

    )
  }
  renderNewMessages() {
    if(this.props.chatStore.new_messages.inited && this.props.chatStore.new_messages.data.indexOf(this.props.id)>-1) {
      return (
        <div>
          <span className="hpadd5 rad3 bg-pc1 fs13 w1">
            {this.props.translateStore.t.evaPrivateChat.new_messeges}
          </span>
        </div>
      )
    }
  }
  renderName() {
    if (this.props.name == 'one_on_one') {
      return this.props.users[0].user_table_nick;
    } else {
      return this.props.name;
    }
  }
  openChatWindow() {
    this.props.chatStore.opened_windows.push(this.props.id);
    this.props.chatStore.float_window=null;
  }
  wrapItem(child) {
    if(this.props.standalone) {
      return (
        <Link className="clear  db tdni b2 solid1-bottom bo-w2 bg-pc1-op90-hover pointer pr hov" to={`/chat/${this.props.id}`}>
          {child}
        </Link>
      )
    } else {
      return (
        <div className="solid1-bottom bo-w2 bg-pc1-op90-hover pointer pr hov" onClick={()=>{ this.openChatWindow(); }}>
          {child}
        </div>
      )
    }
  }
  render() {
    return this.wrapItem(

        <div className="up12 splice">
          <div className="cell s-shrink padd5">
            <div className="chatAvatar">
              {this.renderAvatar()}
            </div>
          </div>
          <div className="cell s-auto padd5">
            {this.renderName()}
            {this.renderNewMessages()}
          </div>
          {this.props.chat_user_opened=='1'?(
            <div className="cell s-shrink s-middle padd5">
              <i className="mdi mdi-close lh10 fs24 pc1-op50 op-hov pc1-hover" onClick={(e)=>{ e.preventDefault(); e.stopPropagation(); this.props.closeChat(this.props.id); }}></i>
            </div>
          ):(
            <div className="cell s-shrink s-middle padd5">
              <i className="mdi mdi-arrow-up lh10 fs24 pc1-op50 op-hov pc1-hover" onClick={(e)=>{ e.preventDefault(); e.stopPropagation(); this.props.openChat(this.props.id); }}></i>
            </div>
          )}
        </div>

    )
  }
}

function mapStateToProps(state) {
  return {
    me:state.me,
    chat_new_messages:state.chat_new_messages,
    t: state.translate
  }
}

export default inject("meStore","translateStore","chatStore")(observer(ChatListItem));